<template>
  <div id="main-content" class="parent-upload-history-detail">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <template v-if="notificationDetail">
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.full_name') }}:</span>
            <span class="info-span">
              <template v-if="notificationDetail.parent_info">{{ notificationDetail.parent_info.name }}</template>
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.time') }}:</span>
            <span class="info-span">{{ $moment(notificationDetail.created_at).format('YYYY-MM-DD h:mm:ss') }}</span>
          </el-col>
        </el-row>

        <el-row style="padding-top: 20px">
          <table class="bus-list">
            <tr>
              <th width="5%">#</th>
              <th width="15%">{{ $t('common.label') }}</th>
              <th width="40%">{{ $t('common.old') }}</th>
              <th width="40%">{{ $t('common.new') }}</th>
            </tr>
            <tr v-for="(changeItem, index) in changeList" :key="index"
                v-show="index >= itemPerPage*(currentPage-1) && index < itemPerPage*currentPage">
              <td>{{ index + 1 }}</td>
              <td>{{ changeItem.label }}</td>
              <td>
                <template v-if="changeItem.old">
                  <img v-if="changeItem.type === 'image'" :src="changeItem.old" />
                  <span v-else>{{ changeItem.old }}</span>
                </template>
              </td>
              <td>
                <template v-if="changeItem.new">
                  <img v-if="changeItem.type === 'image'" :src="changeItem.new" />
                  <span v-else>{{ changeItem.new }}</span>
                </template>
              </td>
            </tr>
          </table>
        </el-row>
      </template>
    </el-col>
  </div>
</template>

<script>
  import { ITEM_PER_PAGE, GENDER_FEMALE } from '@/config'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: 'ListParentUpdateProfile',
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/notification/parent-update-profile?action=back`,
        title: 'notification.parent_profile_change',
        currentPage: 1,
        itemPerPage: ITEM_PER_PAGE,
        notificationDetail: null
      }
    },
    methods: {
      getLabel (field) {
        return this.$t(`common.${field}`)
      }
    },
    mounted: function () {
      let successCallback = (response) => {
        this.notificationDetail = Object.assign({}, response.data.data.notification_info)
      }

      let payload = {
        successCallback,
        id: this.$route.query.id
      }

      this.$store.dispatch('notification/retrieveParentUpdateHistoryDetail', payload)
    },
    computed: {
      changeList: function () {
        let changeList = []

        if (this.notificationDetail) {
          if (this.notificationDetail.new && Object.keys(this.notificationDetail.new).length) {
            let oldData = this.notificationDetail.old || {}
            let newData = this.notificationDetail.new

            for (let field in newData) {
              let changeItem = {}
              changeItem.type = field === 'image' ? 'image' : 'text'
              changeItem.label = this.getLabel(field)
              changeItem.new = newData[field]

              if (oldData[field]) {
                changeItem.old = oldData[field]
              }

              if (field.indexOf('gender') !== -1) {
                changeItem.new = parseInt(changeItem.new) === GENDER_FEMALE ? this.$t('common.female') : this.$t('common.male')

                if (changeItem.old) {
                  changeItem.old = parseInt(changeItem.old) === GENDER_FEMALE ? this.$t('common.female') : this.$t('common.male')
                }
              }

              changeList.push(changeItem)
            }
          }
        }

        return changeList
      }
    }
  }
</script>
<style lang="scss">
  .parent-upload-history-detail {
    img {
      display: block;
      max-width: 200px;
      margin: 0 auto;
    }

    td, th {
      padding: 10px;
    }
  }

</style>